import ANGOptOutModal from './ANGOptOutModal.container';

export default ANGOptOutModal;
